// Le menu de l'entreprise : quels modules il montre, pour tout le monde.
// Stocké dans organizations.parametres.menu, à côté des autres réglages.

import {
  avecModulesMasques,
  MASQUES_PAR_DEFAUT,
  modulesMasques,
} from '@imp/shared/menu-entreprise';
import { useQuery } from '@tanstack/react-query';

import { supabase } from '@/lib/supabase';
import { ORG_ID } from '@/modules/clients/api';

export const CLE_MENU = ['menu-entreprise'] as const;

async function lireParametres(): Promise<unknown> {
  const { data, error } = await supabase
    .from('organizations')
    .select('parametres')
    .eq('id', ORG_ID)
    .single();
  if (error) throw new Error(error.message);
  return (data as { parametres: unknown } | null)?.parametres ?? null;
}

export async function getModulesMasques(): Promise<string[]> {
  return modulesMasques(await lireParametres());
}

/**
 * Enregistre le choix. Les autres réglages de l'organisation (SMS, pause…)
 * vivent dans le même objet : on relit, on fusionne, on réécrit — jamais on
 * n'écrase.
 */
export async function setModulesMasques(masques: readonly string[]): Promise<void> {
  const parametres = avecModulesMasques(await lireParametres(), masques);
  const { error } = await supabase.from('organizations').update({ parametres }).eq('id', ORG_ID);
  if (error) throw new Error(error.message);
}

/**
 * Les modules masqués du menu. Tant que la lecture n'a pas abouti — ou si elle
 * échoue — le menu suit le choix par défaut : un réglage illisible ne doit
 * pas vider le menu, ni y faire revenir d'un coup les modules masqués.
 */
export function useModulesMasques(): readonly string[] {
  const q = useQuery({ queryKey: CLE_MENU, queryFn: getModulesMasques, staleTime: 60_000 });
  return q.data ?? MASQUES_PAR_DEFAUT;
}
